var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbrPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9492 6.3224H11.4992V3.1724C11.4992 1.9124 10.4867 0.899902 9.24922 0.899902H4.74922C3.51172 0.899902 2.49922 1.9124 2.49922 3.1724V6.3224H2.04922C1.30672 6.3224 0.699219 6.9299 0.699219 7.6724V14.8499C0.699219 16.0874 1.71172 17.0999 2.94922 17.0999H11.0717C12.3092 17.0999 13.2992 16.0874 13.2992 14.8499V7.6724C13.2992 6.9299 12.6917 6.3224 11.9492 6.3224ZM3.39922 3.1724C3.39922 2.4074 4.00672 1.7999 4.74922 1.7999H9.24922C9.99172 1.7999 10.5992 2.4074 10.5992 3.1724V6.3224H3.39922V3.1724ZM12.3992 14.8499C12.3992 15.5924 11.7917 16.1999 11.0717 16.1999H2.94922C2.20672 16.1999 1.59922 15.5924 1.59922 14.8499V7.6724C1.59922 7.4249 1.80172 7.2224 2.04922 7.2224H2.49922H11.4992H11.9492C12.1967 7.2224 12.3992 7.4249 12.3992 7.6724V14.8499Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.64844 12.6224C5.64844 13.1174 6.05344 13.5224 6.54844 13.5224H7.44844C7.94344 13.5224 8.34844 13.1174 8.34844 12.6224V9.8999H5.64844V12.6224ZM6.54844 10.7999H7.44844V12.6224V13.0724V12.6224H6.54844V10.7999Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrPadlock);
export default __webpack_public_path__ + "static/media/ubr-padlock.dce1e49e89d6f88c8fa058124010a74d.svg";
export { ForwardRef as ReactComponent };